import { BaseEntity } from "../base/base-entity";
import { convertToFormattedId } from "../../utils/id-formatter";
import { ApplyStatus } from "../application/application-entity";

export type RemovedApplicationType = {
  readonly id: string;
  readonly version: Number;
  readonly procedureId: string;
  readonly procedureVersion: number;
  readonly name: string;
  readonly status: ApplyStatus;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly removedAt: string;
  readonly createdAtUnixSecond: number;
  readonly updatedAtUnixSecond: number;
  readonly orgId: string;
};

export class RemovedApplicationEntity extends BaseEntity {
  public readonly id: string;
  public readonly version: Number;
  public readonly procedureId: string;
  public readonly procedureVersion: number;
  public readonly name: string;
  public readonly status: ApplyStatus;
  public readonly createdAt: string;
  public readonly updatedAt: string;
  public readonly removedAt: string;
  public readonly createdAtDate: Date;
  public readonly updatedAtDate: Date;
  public readonly orgId: string;

  constructor(values: RemovedApplicationType) {
    super();
    this.id = values.id;
    this.version = values.version;
    this.procedureId = values.procedureId;
    this.procedureVersion = values.procedureVersion;
    this.name = values.name;
    this.status = values.status;
    this.createdAt = values.createdAt;
    this.updatedAt = values.updatedAt;
    this.removedAt = values.removedAt;
    this.createdAtDate = new Date(values.createdAtUnixSecond * 1000);
    this.updatedAtDate = new Date(values.updatedAtUnixSecond * 1000);
    this.orgId = values.orgId;
  }

  get formattedId() {
    return convertToFormattedId(this.id);
  }
}
